import { reduce } from 'ramda'


export const DELIMITER = 'delimiter' as const

export function delimiterToProp<T extends { hasDelimiter?: boolean }>(
  from: Array<T | typeof DELIMITER>
): Array<T> {
  return reduce((acc, val) => {
    if (val === DELIMITER) {
      const lastElemIndex = acc.length - 1
      acc[lastElemIndex].hasDelimiter = true
    }
    if (typeof val !== 'string') {
      acc.push(val)
    }
    return acc
  }, [] as Array<T>, from)
}
